import { useEffect, useState } from "react";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Highlights from "@/components/Highlights";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Governo from "@/components/Governo";
import Faith from "@/components/Faith";
import SePrimacial from "@/components/SePrimacial";
import Prelacies from "@/components/Prelacies";
import ClergyBirthdays from "@/components/ClergyBirthdays";
import AgendaSection from "@/components/AgendaSection";
import NewsSection from "@/components/NewsSection";
import LiveSection from "@/components/LiveSection";
import Shortcuts from "@/components/Shortcuts";
import Documents from "@/components/Documents";
import Doacoes from "@/components/Doacoes";
import GallerySection from "@/components/GallerySection";
import Footer from "@/components/Footer";
import PrayerModal from "@/components/PrayerModal";
import ChatWidget from "@/components/ChatWidget";
import Seo, { orgJsonLd } from "@/lib/seo";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [prayerOpen, setPrayerOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const t = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="bg-[#FBF9F4] text-[#1C1917]">
      <Seo jsonLd={orgJsonLd()} />
      <div className="grain-overlay" aria-hidden="true" />
      <Header onPrayer={() => setPrayerOpen(true)} />
      <main>
        <Hero />
        <Highlights />
        <Marquee />
        <Manifesto />
        <Governo />
        <Faith />
        <SePrimacial />
        <GallerySection />
        <Prelacies />
        <ClergyBirthdays />
        <AgendaSection />
        <NewsSection />
        <LiveSection />
        <Shortcuts />
        <Documents />
        <Doacoes />
      </main>
      <Footer />
      <PrayerModal open={prayerOpen} onClose={() => setPrayerOpen(false)} />
      <ChatWidget />
    </div>
  );
}
